import { FormattedMessage } from 'react-intl';
import { GreenLabel, RedLabel, YellowLabel } from '../transcriptions/styles';

export function getConfidenceLabel(confidence: number) {
  switch (true) {
    case confidence <= 30:
      return (
        <GreenLabel>
          <FormattedMessage id="audit.transcriptionScreen.high" defaultMessage="Alta" />
        </GreenLabel>
      );
    case confidence > 30 && confidence <= 35:
      return (
        <YellowLabel>
          <FormattedMessage id="audit.transcriptionScreen.medium" defaultMessage="Media" />
        </YellowLabel>
      );

    case confidence > 36:
      return (
        <RedLabel>
          <FormattedMessage id="audit.transcriptionScreen.low" defaultMessage="Baja" />
        </RedLabel>
      );

    default:
      return 'N/A';
  }
}
